import React, { useEffect, useState } from 'react'
import { Calendar, Gold, GreenTick, Silver, Upi, Wallet } from '../../../assests/ExportImageIcon'
import service from '../../../services/service'
import endpoints from '../../../services/endpoints'
import './manageSubscription.css'

const BackArrow = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M15 9H4M8 5l-4 4 4 4" stroke="#026D4D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const formatDate = (value) => {
    if (!value) return '—'
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return value
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
}

const getPlanIcon = (planType) => {
    const type = (planType || '').toLowerCase()
    if (type === 'gold') return Gold
    return Silver
}

const getPaymentIcon = (paymentMethod) => {
    const method = (paymentMethod || '').toLowerCase()
    if (method === 'upi') return Upi
    return Wallet
}

const ManageSubscription = ({ onBack }) => {
    const [subscription, setSubscription] = useState(null)
    const [billingHistory, setBillingHistory] = useState([])
    const [loading, setLoading] = useState(true)
    const [autoRenewal, setAutoRenewal] = useState(true)

    useEffect(() => {
        let mounted = true

        service.get(endpoints.subscriptions.me, {}, { silent: true })
            .then(({ data }) => {
                if (!mounted) return
                const body = data?.data || {}
                setSubscription(body.subscription || null)
                setBillingHistory(Array.isArray(body.billing_history) ? body.billing_history : [])
                setAutoRenewal(Boolean(body.subscription?.auto_renewal))
            })
            .catch(() => {
                if (!mounted) return
                setSubscription(null)
                setBillingHistory([])
            })
            .finally(() => {
                if (mounted) setLoading(false)
            })

        return () => { mounted = false }
    }, [])

    if (loading) {
        return (
            <div className='manageSubscription'>
                <div className='tripDocHeader' onClick={onBack}>
                    <BackArrow />
                    <span className='bsSectionTitle'>Manage Subscription</span>
                </div>
                <p className='securityMenuItem__subtitle mt-3'>Loading subscription details...</p>
            </div>
        )
    }

    if (!subscription) {
        return (
            <div className='manageSubscription'>
                <div className='tripDocHeader' onClick={onBack}>
                    <BackArrow />
                    <span className='bsSectionTitle'>Manage Subscription</span>
                </div>
                <p className='securityMenuItem__subtitle mt-3'>No active subscription found.</p>
            </div>
        )
    }

    const priceLabel = subscription.price
        ? `${subscription.currency_symbol || ''}${subscription.price}${subscription.billing_cycle ? `/${subscription.billing_cycle}` : ''}`
        : '—'

    return (
        <div className='manageSubscription'>
            <div className='tripDocHeader' onClick={onBack}>
                <BackArrow />
                <span className='bsSectionTitle'>Manage Subscription</span>
            </div>

            <div className='manageSubCurrentPlan paddingCommon20 borderRadius20 mt-3'>
                <div className='manageSubCurrentPlan__head'>
                    <span className='manageSubCurrentPlan__icon'>
                        <img src={getPlanIcon(subscription.plan_type)} alt="" />
                    </span>
                    <div className='manageSubCurrentPlan__headInfo'>
                        <div className='manageSubCurrentPlan__name'>{subscription.plan_name || '—'}</div>
                        <div className='manageSubCurrentPlan__price'>{priceLabel}</div>
                    </div>
                    <span className='manageSubCurrentPlan__badge'>{subscription.status || (subscription.is_premium ? 'Active' : 'Inactive')}</span>
                </div>

                <div className='bsFareRow'>
                    <span>Started on:</span>
                    <span>{formatDate(subscription.started_at)}</span>
                </div>
                <div className='bsFareRow'>
                    <span>Next Billing:</span>
                    <span>{formatDate(subscription.next_billing_date)}</span>
                </div>
                <div className='bsFareRow'>
                    <span>Payment method:</span>
                    <span>{subscription.payment_method || '—'}</span>
                </div>

                {!subscription.is_premium && (
                    <button type='button' className='commonBtn w-100 mt-3'>Upgrade to Gold</button>
                )}
            </div>

            {Array.isArray(subscription.features) && subscription.features.length > 0 && (
                <>
                    <div className='bsSectionTitle mt-4'>Your Benefits</div>
                    <div className='bgWhite commonBorder borderRadius20'>
                        {subscription.features.map((feature, index) => {
                            const text = typeof feature === 'string' ? feature : feature.text
                            return (
                                <div className='securityMenuItem' key={index}>
                                    <span className='securityMenuItem__icon'>
                                        <img src={GreenTick} alt="" />
                                    </span>
                                    <div className='securityMenuItem__info'>
                                        <div className='securityMenuItem__title'>{text}</div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </>
            )}

            {/* <div className='bsSectionTitle mt-4'>Preference</div>
            <div className='bsBox'>
                <div className='manageSubToggleRow'>
                    <div>
                        <div className='securityMenuItem__title'>Auto Renewal</div>
                        <div className='securityMenuItem__subtitle'>
                            {autoRenewal
                                ? `Your subscription will automatically renew on ${formatDate(subscription.next_billing_date)}`
                                : 'Auto renewal is turned off'}
                        </div>
                    </div>
                    <label className='toggleSwitch'>
                        <input type='checkbox' checked={autoRenewal} onChange={() => setAutoRenewal((prev) => !prev)} />
                        <span className='toggleSwitch__slider' />
                    </label>
                </div>
            </div> */}

            <div className='bsSectionTitle mt-4'>Payment Method</div>
            <div className='bgWhite commonBorder borderRadius20'>
                <div className='securityMenuItem'>
                    <span className='manageSub__iconBox'>
                        <img src={getPaymentIcon(subscription.payment_method)} alt="" />
                    </span>
                    <div className='securityMenuItem__info'>
                        <div className='securityMenuItem__title'>{subscription.payment_method || '—'}</div>
                        <div className='securityMenuItem__subtitle'>Default payment method</div>
                    </div>
                </div>
            </div>

            <div className='bsSectionTitle mt-4'>Billing History</div>
            <div className='bgWhite commonBorder borderRadius20'>
                {billingHistory.length === 0 ? (
                    <div className='securityMenuItem'>
                        <div className='securityMenuItem__info'>
                            <div className='securityMenuItem__subtitle'>No billing history yet.</div>
                        </div>
                    </div>
                ) : (
                    billingHistory.map((bill) => (
                        <div className='securityMenuItem' key={bill.id}>
                            <span className='securityMenuItem__icon'>
                                <img src={Calendar} alt="" />
                            </span>
                            <div className='securityMenuItem__info'>
                                <div className='securityMenuItem__title'>{bill.plan_name}</div>
                                <div className='securityMenuItem__subtitle'>
                                    Paid on {formatDate(bill.paid_at)} · {bill.currency}{bill.amount}
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {!subscription.is_premium && (
                <button type='button' className='travellerAddBtn mt-4'>Upgrade Subscription</button>
            )}
        </div>
    )
}

export default ManageSubscription
